function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 2199 1132",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M271.201,993.937l-197.382,0c-19.578,0 -38.354,-7.777 -52.198,-21.621c-13.844,-13.843 -21.621,-32.62 -21.621,-52.198l0,-809.39c-0,-29.367 11.666,-57.531 32.432,-78.296c20.765,-20.766 48.929,-32.432 78.296,-32.432l1350.1,0c64.276,-0 123.922,33.443 157.45,88.281l197.004,322.212c14.199,23.223 34.542,42.069 58.781,54.455l244.42,124.897c49.382,25.234 80.459,76.013 80.459,131.468l-0,198.805c-0,19.578 -7.778,38.355 -21.622,52.198c-13.843,13.844 -32.619,21.621 -52.197,21.621l-138.136,0c0,-93.734 -76.1,-169.834 -169.834,-169.834c-93.735,-0 -169.835,76.1 -169.835,169.834l-1036.45,0c-0,-93.734 -76.101,-169.834 -169.835,-169.834c-93.734,-0 -169.835,76.1 -169.835,169.834Zm1369.81,-547.93c6.676,-0 12.832,-3.606 16.097,-9.429c3.265,-5.824 3.13,-12.956 -0.352,-18.652l-160.325,-262.221c-13.411,-21.935 -37.269,-35.312 -62.98,-35.312l-261.059,-0c-20.385,-0 -36.91,16.525 -36.91,36.909l0,141.067c0,81.538 66.1,147.638 147.638,147.638l357.891,-0Zm-1199.97,410.867c75.647,0 137.063,61.416 137.063,137.063c0,75.648 -61.416,137.064 -137.063,137.064c-75.647,-0 -137.063,-61.416 -137.063,-137.064c-0,-75.647 61.416,-137.063 137.063,-137.063Zm1376.12,0c75.647,0 137.063,61.416 137.063,137.063c-0,75.648 -61.416,137.064 -137.063,137.064c-75.648,-0 -137.064,-61.416 -137.064,-137.064c0,-75.647 61.416,-137.063 137.064,-137.063Z",
    style: {
      fill: "#141f2a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanIcon);
export default __webpack_public_path__ + "static/media/VanIcon.f3db74c143e5e0789435c4eb9be7da8f.svg";
export { ForwardRef as ReactComponent };